<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!isauth">
          <div class="tcf-notedit-spinner" v-if="islive">
            未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
          </div>
          <div class="tcf-notedit-spinner" v-if="!islive">
            授权小程序未开通直播权限，请前往微信公众平台开通小程序直播权限
          </div>
        </div>
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
<!--            <el-form-item label="直播间类型">-->
<!--              <el-select v-model="searchForm.type" clearable style="width: 140px">-->
<!--                <el-option label="手机直播" :value="0" />-->
<!--                <el-option label="推流" :value="1" />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加直播</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px"
            >
              <el-table-column
                label="直播卡片封面"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.feedsimgurl"
                    fit="cover"
                    style="width: 40px;height: 40px;"
                    :preview-src-list="[scope.row.feedsimgurl]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="直播名称"
                min-width="200"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="直播时间"
                width="320"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.starttime }}～{{ scope.row.endtime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="直播商品"
                width="140"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button size="mini" @click="checkGoods(scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="anchor"
                label="主播"
                width="140"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                label="直播类型"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini">推流</el-tag>
                  <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini">手机直播</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button icon="el-icon-search" size="mini" @click="editRow(scope.row)">查看</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-form ref="editForm" size="small" :model="editForm" label-width="120px" :rules="dilogrules">
        <el-form-item label="直播间名字" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入直播间名字" style="width: 300px" show-word-limit maxlength="17" :disabled="isCheck" />
          <span style="color:#99a9bf;font-size: 12px"> 必须是3-17个字</span>
        </el-form-item>
<!--        <el-form-item label="直播类型" prop="type">-->
<!--          <el-radio-group v-model="editForm.type">-->
<!--            <el-radio :label="0" :disabled="isCheck">手机直播</el-radio>-->
<!--            <el-radio :label="1" :disabled="isCheck">推流</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="开播时间" prop="time">
          <el-date-picker
            v-model="editForm.time"
            :disabled="isCheck"
            style="width: 480px"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
          <div style="color:#99a9bf;font-size: 12px"> 开播时间需要在当前时间的10分钟后 并且开始时间不能在6个月后<br>开播时间和结束时间间隔不得短于30分钟，不得超过24小时</div>
        </el-form-item>
        <el-form-item label="官方收录">
          <el-radio-group v-model="editForm.feedspublic">
            <el-radio :label="1" :disabled="isCheck">开启</el-radio>
            <el-radio :label="0" :disabled="isCheck">关闭</el-radio>
          </el-radio-group>
          <div style="color:#99a9bf;font-size: 12px"> 开启后本场直播将有可能被微信官方推荐</div>
        </el-form-item>
        <el-form-item label="主播昵称" prop="anchor">
          <el-input v-model="editForm.anchor" placeholder="请输入主播昵称" show-word-limit style="width: 250px" maxlength="15" :disabled="isCheck" />
          <span style="color:#99a9bf;font-size: 12px"> 必须为2-15个字</span>
        </el-form-item>
        <el-form-item label="主播微信账号" prop="anchorwechat">
          <el-input v-model="editForm.anchorwechat" placeholder="请输入主播微信账号" show-word-limit style="width: 250px" maxlength="50" :disabled="isCheck" />
          <el-popover
            placement="right"
            width="150"
            :key="anchorwechatKey"
            trigger="hover">
            <div style="width: 126px;text-align: center">请扫描进行认证</div>
            <el-image style="width: 126px;height: 126px;margin-top: 5px" src="https://res.wx.qq.com/op_res/9rSix1dhHfK4rR049JL0PHJ7TpOvkuZ3mE0z7Ou_Etvjf-w1J_jVX0rZqeStLfwh"></el-image>
            <span style="color:#99a9bf;font-size: 12px" slot="reference">必须是已<b>实名认证</b> <i class="el-icon-question"></i></span>
          </el-popover>
        </el-form-item>
        <el-form-item label="主播副号">
          <el-input v-model="editForm.subanchorwechat" placeholder="请输入主播副号" show-word-limit style="width: 250px" maxlength="50" :disabled="isCheck" />
          <el-popover
            placement="right"
            :key="subanchorwechatKey"
            width="150"
            trigger="hover">
            <div style="width: 126px;text-align: center">请扫描进行认证</div>
            <el-image style="width: 126px;height: 126px;margin-top: 5px" src="https://res.wx.qq.com/op_res/9rSix1dhHfK4rR049JL0PHJ7TpOvkuZ3mE0z7Ou_Etvjf-w1J_jVX0rZqeStLfwh"></el-image>
            <span style="color:#99a9bf;font-size: 12px" slot="reference">必须是已<b>实名认证</b> <i class="el-icon-question"></i></span>
          </el-popover>
        </el-form-item>
        <el-row v-if="isCheck === false">
          <el-form-item label="分享卡片封面" prop="shareimg">
            <div style="color:#99a9bf;font-size: 12px"> 用户在微信对话框内分享的直播间将以分享卡片的形式呈现</div>
            <div style="color:#99a9bf;font-size: 12px"> 建议尺寸：800像素 * 640像素，图片大小不得超过1M</div>
            <SingleImgRestrict :size="[200,160]" :key="shareimgkey" v-model="editForm.shareimg" :oldurl="editForm.oldshareimgurl" :restrict="1"/>
          </el-form-item>
          <el-form-item label="直播卡片封面" prop="feedsimg">
            <div style="color:#99a9bf;font-size: 12px"> 官方推荐的小程序直播将会出现在购物直播频道内</div>
            <div style="color:#99a9bf;font-size: 12px"> 建议尺寸：800像素 * 800像素，图片大小不超过300KB</div>
            <SingleImgRestrict :size="[200,200]" :key="feedsimgkey" v-model="editForm.feedsimg" :oldurl="editForm.oldfeedsimgurl" :restrict="0.3"/>
          </el-form-item>
          <el-form-item label="直播间背景墙" prop="coverimg">
            <div style="color:#99a9bf;font-size: 12px"> 直播间背景墙是每个直播间的默认背景</div>
            <div style="color:#99a9bf;font-size: 12px"> 建议尺寸：600像素 * 1300像素，图片大小不得超过 3M</div>
            <SingleImgRestrict :size="[150,325]" :key="coverimgkey" v-model="editForm.coverimg" :oldurl="editForm.oldcoverimgurl" :restrict="3"/>
          </el-form-item>
        </el-row>
        <el-row v-if="isCheck">
          <el-form-item label="分享卡片封面" prop="shareimg">
            <el-image style="width: 200px; height: 160px" :src="editForm.oldshareimgurl" :preview-src-list="[editForm.oldshareimgurl]" />
          </el-form-item>
          <el-form-item label="直播卡片封面" prop="feedsimg">
            <el-image style="width: 200px; height: 200px" :src="editForm.oldfeedsimgurl" :preview-src-list="[editForm.oldfeedsimgurl]" />
          </el-form-item>
          <el-form-item label="直播间背景墙" prop="coverimg">
            <el-image style="width: 150px; height: 325px" :src="editForm.oldcoverimgurl" :preview-src-list="[editForm.oldcoverimgurl]" />
          </el-form-item>
        </el-row>
        <el-form-item label="点赞" prop="like">
          <el-radio-group v-model="editForm.like">
            <el-radio :label="0" :disabled="isCheck">开启</el-radio>
            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>
          </el-radio-group>
          <div style="color:#99a9bf;font-size: 12px"> 若关闭，观众端将隐藏点赞按钮，直播开始后不允许开启</div>
        </el-form-item>
        <el-form-item label="货架" prop="goods">
          <el-radio-group v-model="editForm.goods">
            <el-radio :label="0" :disabled="isCheck">开启</el-radio>
            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>
          </el-radio-group>
          <div style="color:#99a9bf;font-size: 12px"> 若关闭，观众端将隐藏商品货架，直播开始后不允许开启</div>
        </el-form-item>
        <el-form-item label="评论" prop="comment">
          <el-radio-group v-model="editForm.comment">
            <el-radio :label="0" :disabled="isCheck">开启</el-radio>
            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>
          </el-radio-group>
          <div style="color:#99a9bf;font-size: 12px"> 若关闭，观众端将隐藏评论入口，直播开始后不允许开启</div>
        </el-form-item>
<!--        <el-form-item label="回放">-->
<!--          <el-radio-group v-model="editForm.replay">-->
<!--            <el-radio :label="0" :disabled="isCheck">开启</el-radio>-->
<!--            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>-->
<!--          </el-radio-group>-->
<!--          <div style="color:#99a9bf;font-size: 12px"> 直播开始后允许开启</div>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="分享">-->
<!--          <el-radio-group v-model="editForm.share">-->
<!--            <el-radio :label="0" :disabled="isCheck">开启</el-radio>-->
<!--            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>-->
<!--          </el-radio-group>-->
<!--          <div style="color:#99a9bf;font-size: 12px"> 直播开始后不允许修改</div>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="客服">-->
<!--          <el-radio-group v-model="editForm.kf">-->
<!--            <el-radio :label="0" :disabled="isCheck">开启</el-radio>-->
<!--            <el-radio :label="1" :disabled="isCheck">关闭</el-radio>-->
<!--          </el-radio-group>-->
<!--          <div style="color:#99a9bf;font-size: 12px"> 直播开始后允许开启</div>-->
<!--        </el-form-item>-->
        <el-form-item v-if="!isCheck">
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="直播商品详情"
      :visible.sync="goodsdialogVisible"
      width="43%"
      style="margin:auto"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <el-row style="text-align: center;">
        <el-col :span="24">
          <el-transfer
            v-model="goodskeylist"
            style="text-align: left; display: inline-block"
            target-order="push"
            :titles="['未选择商品', '已选择商品']"
            :data="goodslist"
          >
            <div slot-scope="{ option }">
              <el-avatar :size="30" :src="option.icon" style="vertical-align:middle;" />
              <span> {{ option.label }}</span>
            </div>
          </el-transfer>
          <div style="width:100%;text-align: center;margin-top: 10px;">
            <el-button :loading="goodsLoading" type="primary" size="small" @click="SubGoods">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImgRestrict from '@/components/upload/SingleImgRestrict'
import {
  getDelLiveList,
  addDelLive,
  delDelLive,
  getDelLiveGoodsList,
  addDelLiveItemGoods,
  getDelLiveItemGoodsList,
  uploadFileWx,
  getDelShopInfo
} from '@/api/dealer'
export default {
  name: 'delzbhd',
  components: {
    SingleImgRestrict
  },
  data() {
    return {
      searchForm: {
        type: null,
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dilogrules: {
        name: [{ required: true, message: '请输入直播间名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择直播类型', trigger: 'change' }],
        time: [{ required: true, message: '请选择开播时间与结束时间', trigger: 'change' }],
        anchor: [{ required: true, message: '请输入主播昵称', trigger: 'blur' }],
        anchorwechat: [{ required: true, message: '请输入主播微信号', trigger: 'blur' }],
        shareimg: [{ required: true, message: '请上传分享卡片封面', trigger: 'change' }],
        feedsimg: [{ required: true, message: '请上传直播卡片封面', trigger: 'change' }],
        coverimg: [{ required: true, message: '请上传直播默认背景', trigger: 'change' }],
        like: [{ required: true, message: '请选择是否开启点赞功能', trigger: 'change' }],
        goods: [{ required: true, message: '请选择是否开启货架功能', trigger: 'change' }],
        comment: [{ required: true, message: '请选择是否开启评论', trigger: 'change' }]
      },
      subanchorwechatKey: '',
      anchorwechatKey: '',
      editForm: {
        name: '',
        type: 0,
        time: [],
        feedspublic: 1,
        anchor: '',
        anchorwechat: '',
        subanchorwechat: '',
        shareimg: null,
        oldshareimgurl: '',
        feedsimg: null,
        oldfeedsimgurl: '',
        coverimg: null,
        oldcoverimgurl: '',
        like: 0,
        goods: 0,
        comment: 0,
        replay: 0,
        share: 0,
        kf: 0
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      isCheck: false,
      shareimgkey: '',
      feedsimgkey: '',
      coverimgkey: '',
      dlid: null,
      dlgid: '',
      goodsdialogVisible: false,
      goodsloading: false,
      goodsLoading: false,
      goodslist: [],
      livegoodslist: [],
      goodskeylist: [],
      wxshareimg: '',
      wxfeedsimg: '',
      wxcoverimg: '',
      isauth: true,
      islive: true
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    getDelShopInfo({ delid: this.user.delid }).then(response => {
      if (response.data !== null && response.data !== undefined) {
        if (response.data.appid !== null && response.data.appid !== '' && response.data.appid !== undefined) {
          if (response.data.islive === 0) {
            this.islive = false
            this.isauth = false
          }
        } else {
          this.isauth = false
        }
      } else {
        this.isauth = false
      }
    })
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        type: this.searchForm.type,
        search: this.searchForm.search
      }
      getDelLiveList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      if (row === null) {
        this.isCheck = false
        this.editTitle = '添加直播活动'
        this.editForm.name = null
        this.editForm.type = 0
        this.editForm.time = []
        this.editForm.feedspublic = 1
        this.editForm.anchor = null
        this.editForm.anchorwechat = null
        this.editForm.subanchorwechat = null
        this.editForm.shareimg = null
        this.editForm.oldshareimgurl = null
        this.editForm.feedsimg = null
        this.editForm.oldfeedsimgurl = null
        this.editForm.coverimg = null
        this.editForm.oldcoverimgurl = null
        this.editForm.like = 0
        this.editForm.goods = 0
        this.editForm.comment = 0
        this.editForm.replay = 0
        this.editForm.share = 0
        this.editForm.kf = 0
      } else {
        this.isCheck = true
        this.editTitle = '查看直播活动'
        this.editForm.name = row.name
        this.editForm.type = row.type
        var _time = []
        _time.push(row.starttime)
        _time.push(row.endtime)
        this.editForm.time = _time
        this.editForm.feedspublic = row.isfeedspublic
        this.editForm.anchor = row.anchor
        this.editForm.anchorwechat = row.anchorwechat
        this.editForm.subanchorwechat = row.subanchorwechat
        this.editForm.shareimg = { imgid: row.shareimgid, imgurl: row.shareimgurl }
        this.editForm.oldshareimgurl = row.shareimgurl
        this.editForm.feedsimg = { imgid: row.feedsimgid, imgurl: row.feedsimgurl }
        this.editForm.oldfeedsimgurl = row.feedsimgurl
        this.editForm.coverimg = { imgid: row.coverimgid, imgurl: row.coverimgurl }
        this.editForm.oldcoverimgurl = row.coverimgurl
        this.editForm.like = row.closelike
        this.editForm.goods = row.closegoods
        this.editForm.comment = row.closecomment
        this.editForm.replay = row.closereplay
        this.editForm.share = row.closeshare
        this.editForm.kf = row.closekf
      }
      this.shareimgkey = (new Date().getTime() + 333).toString()
      this.feedsimgkey = (new Date().getTime() + 555).toString()
      this.coverimgkey = (new Date().getTime() + 777).toString()
      this.subanchorwechatKey = (new Date().getTime() + 888).toString()
      this.anchorwechatKey = (new Date().getTime() + 999).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            uploadFileWx({ imgid: this.editForm.shareimg.imgid, type: 'image' }).then(response => {
              this.wxshareimg = response.msg
              uploadFileWx({ imgid: this.editForm.feedsimg.imgid, type: 'image' }).then(response => {
                this.wxfeedsimg = response.msg
                uploadFileWx({ imgid: this.editForm.coverimg.imgid, type: 'image' }).then(response => {
                  this.wxcoverimg = response.msg
                  const data = {
                    delid: this.user.delid,
                    type: this.editForm.type,
                    name: this.editForm.name,
                    starttime: this.editForm.time[0],
                    endtime: this.editForm.time[1],
                    anchor: this.editForm.anchor,
                    anchorwechat: this.editForm.anchorwechat,
                    subanchorwechat: this.editForm.subanchorwechat,
                    shareimgid: this.editForm.shareimg.imgid,
                    feedsimgid: this.editForm.feedsimg.imgid,
                    coverimgid: this.editForm.coverimg.imgid,
                    isfeedspublic: this.editForm.feedspublic,
                    closelike: this.editForm.like,
                    closegoods: this.editForm.goods,
                    closecomment: this.editForm.comment,
                    closereplay: this.editForm.replay,
                    closeshare: this.editForm.share,
                    closekf: this.editForm.kf,
                    wxshareimg: this.wxshareimg,
                    wxfeedsimg: this.wxfeedsimg,
                    wxcoverimg: this.wxcoverimg
                  }
                  addDelLive(data).then(response => {
                    this.eidtLoading = false
                    this.$message({
                      type: 'success',
                      message: '提交成功'
                    })
                    this.Search()
                    this.dialogVisible = false
                  }).catch(() => {
                    this.eidtLoading = false
                  })
                })
              })
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此直播活动吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delDelLive({ dlid: row.dlid, roomid: row.roomId, delid: row.delid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    checkGoods(row) {
      this.goodslist = []
      this.goodskeylist = []
      this.goodsdialogVisible = true
      this.goodsloading = true
      this.dlid = row.dlid
      const data = {
        delid: this.user.delid,
        page: 1,
        limit: 9999,
        mark: 2
      }
      getDelLiveGoodsList(data).then(response => {
        for (const goods of response.data) {
          this.goodslist.push({
            key: goods.dlgid,
            label: goods.name,
            icon: goods.imgurl,
            disabled: false
          })
        }
        getDelLiveItemGoodsList({ dlid: this.dlid }).then(response => {
          this.goodsloading = false
          this.livegoodslist = response.data
          if (this.goodslist.length !== 0 && this.livegoodslist.length !== 0) {
            this.goodslist.forEach((goods, x) => {
              this.livegoodslist.forEach((live, y) => {
                if (goods.key === live.dlgid) {
                  this.goodskeylist.push(goods.key)
                  this.goodslist[x].disabled = true
                }
              })
            })
          }
        }).catch(() => {
          this.goodsloading = false
        })
      }).catch(() => {
        this.goodsloading = false
      })
    },
    handleClose(done) {
      done()
    },
    SubGoods() {
      if (!this.goodsLoading) {
        this.goodsLoading = true
        this.dlgid = ''
        for (const item of this.goodskeylist) {
          this.dlgid = this.dlgid + item + ','
        }
        if (this.dlgid.length !== 0) {
          this.dlgid = this.dlgid.substring(0, this.dlgid.length - 1)
        }
        const data = {
          dlid: this.dlid,
          dlgid: this.dlgid
        }
        addDelLiveItemGoods(data).then(response => {
          this.goodsLoading = false
          this.$message({
            type: 'success',
            message: '提交成功'
          })
          this.goodsdialogVisible = false
        }).catch(() => {
          this.goodsLoading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
